export default __webpack_public_path__ + "media/src/assets/images/Expedite-283178b4d3a95a263b6d003e0e4297f9.svg";